import { z } from 'zod';
export const analyticsPropertyTypeSchema = z.enum([
    'int64',
    'double',
    'bool',
    'string',
    'enum',
    'json',
]);
export const analyticsPropertyDefinitionSchema = z.object({
    key: z.string(),
    displayName: z.string(),
    description: z.string(),
    type: analyticsPropertyTypeSchema,
    optional: z.boolean(),
    unit: z.string().nullable(),
    enumKey: z.string().nullable(),
    commonDimension: z.string().nullable().optional(),
});
export const analyticsEventVersionSchema = z.object({
    categoryCode: z.number().int().positive(),
    eventCode: z.number().int().positive(),
    eventKey: z.string(),
    displayName: z.string(),
    description: z.string(),
    version: z.number().int().positive(),
    properties: z.array(analyticsPropertyDefinitionSchema),
});
export const analyticsEnumValueSchema = z.object({
    value: z.number().int(),
    key: z.string(),
    displayName: z.string(),
    description: z.string(),
});
export const analyticsEnumDefinitionSchema = z.object({
    key: z.string(),
    csharpTypeName: z.string(),
    displayName: z.string(),
    description: z.string(),
    values: z.array(analyticsEnumValueSchema),
});
export const analyticsCategorySchema = z.object({
    wireCode: z.number().int().positive(),
    key: z.string(),
    displayName: z.string(),
    description: z.string(),
});
export const analyticsSchemaSnapshotContentSchema = z.object({
    protocolVersion: z.number().int().positive(),
    projectSlug: z.string(),
    environmentSlug: z.string(),
    categories: z.array(analyticsCategorySchema),
    enums: z.array(analyticsEnumDefinitionSchema),
    events: z.array(analyticsEventVersionSchema),
});
export const analyticsSchemaSnapshotSchema = z.object({
    revision: z.number().int().positive(),
    hash: z.string(),
    publishedAt: z.string(),
    content: analyticsSchemaSnapshotContentSchema,
});
export const analyticsSchemaDraftCategorySchema = z.object({
    id: z.string().uuid(),
    wireCode: z.number().int().nullable(),
    key: z.string(),
    displayName: z.string(),
    description: z.string(),
});
export const analyticsSchemaDraftEnumValueSchema = z.object({
    id: z.string().uuid(),
    value: z.number().int().nullable(),
    key: z.string(),
    displayName: z.string(),
    description: z.string(),
});
export const analyticsSchemaDraftEnumSchema = z.object({
    id: z.string().uuid(),
    key: z.string(),
    csharpTypeName: z.string(),
    displayName: z.string(),
    description: z.string(),
    values: z.array(analyticsSchemaDraftEnumValueSchema),
});
export const analyticsSchemaDraftPropertySchema = z.object({
    id: z.string().uuid(),
    key: z.string(),
    displayName: z.string(),
    description: z.string(),
    type: analyticsPropertyTypeSchema,
    optional: z.boolean(),
    unit: z.string().nullable(),
    enumId: z.string().uuid().nullable(),
    commonDimension: z.string().nullable(),
});
export const analyticsSchemaDraftEventSchema = z.object({
    id: z.string().uuid(),
    categoryId: z.string().uuid().nullable(),
    eventCode: z.number().int().nullable(),
    eventKey: z.string(),
    displayName: z.string(),
    description: z.string(),
    properties: z.array(analyticsSchemaDraftPropertySchema),
});
export const analyticsSchemaDraftDocumentSchema = z.object({
    protocolVersion: z.literal(1),
    projectSlug: z.string(),
    environmentSlug: z.string(),
    categories: z.array(analyticsSchemaDraftCategorySchema),
    enums: z.array(analyticsSchemaDraftEnumSchema),
    events: z.array(analyticsSchemaDraftEventSchema),
});
export const analyticsWireEventSchema = z.object({
    id: z.string().uuid(),
    q: z.number().int().nonnegative(),
    t: z.number().int(),
    r: z.number().int().nonnegative(),
    g: z.number().int().positive(),
    e: z.number().int().positive(),
    v: z.number().int().positive(),
    p: z.array(z.unknown()),
});
export const analyticsBatchSchema = z.object({
    pv: z.number().int().positive(),
    sr: z.number().int().positive(),
    sh: z.string(),
    bid: z.string().uuid(),
    iid: z.string().uuid(),
    sid: z.string().uuid(),
    si: z.number().int().positive(),
    pf: z.number().int().nonnegative(),
    av: z.string(),
    bn: z.string(),
    sat: z.number().int(),
    ev: z.array(analyticsWireEventSchema),
});
export const analyticsIngestionSuccessSchema = z.object({
    accepted: z.literal(true),
    batchId: z.string().uuid(),
    insertedEvents: z.number().int().nonnegative(),
    duplicateEvents: z.number().int().nonnegative(),
    serverTimeUtcMs: z.number().int(),
    clockSkewed: z.boolean(),
});
//# sourceMappingURL=analytics.js.map